import { environment } from '../../environments/environment';
import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-manager-approval-modal',
  templateUrl: './manager-approval-modal.component.html'
})
export class ManagerApprovalModalComponent {
  form!: FormGroup;
  registerId!: any;
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit() {
    this.registerId = this.config.data.registerId;
    console.log(this.config.data);
    this.form = this.fb.group({
      creditLimit: [
        this.config.data.creditLimit,
        [
          Validators.required,
          Validators.min(0), // no negative values
          Validators.pattern(/^\d+$/) // only numbers
        ]
      ],
      creditDays: [
        this.config.data.creditDays,
        [
          Validators.required,
          Validators.min(0),
          Validators.pattern(/^\d+$/)
        ]
      ],
    });
  }

  submit(event: Event) {
    event.preventDefault(); // Prevent default form submission

    if (this.form.invalid) return;

    const payload = {
      RegisterId: this.registerId,
      CreditLimit: this.form.value.creditLimit,
      CreditDays: this.form.value.creditDays,
    };
    console.log(payload);

    // Call your API
    this.http.post<boolean>(this.baseUrl + '/Register/add-limit', payload,this.httpOptions)
      .subscribe({
        next: (res) => {
          if (res) {
            this.ref.close({ success: true });
          } else {
            // Handle failure case
            alert('Failed to add limit.');
          }
        },
        error: (err) => {
          console.error('API Error:', err);
          alert('Something went wrong.');
        }
      });
  }

  cancel() {
    this.ref.close(null);
  }
}
